import { render, staticRenderFns } from "./RemunerationToCash.vue?vue&type=template&id=2cba913d&scoped=true&"
import script from "./RemunerationToCash.vue?vue&type=script&lang=js&"
export * from "./RemunerationToCash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cba913d",
  null
  
)

export default component.exports